import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useRestrictToLoggedInAndVerified } from '../../../utils/hooks/useRestrictToLoggedInAndVerified';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';

interface Props {
  className?: string;
  deviation: PapiDeviation;
}

const LoginToDownloadButton: React.FC<Props> = ({ className, deviation }) => {
  const { t } = useTranslation();
  const { restrictToLoggedInAndVerified } = useRestrictToLoggedInAndVerified();

  return (
    <ActionBarItemWrapper className={className}>
      <BuyButton
        size="medium"
        rounded={true}
        onClick={restrictToLoggedInAndVerified(ReferralType.ANON_DOWNLOAD)}
        fillContainerWidth
      >
        {t('actionbar.download.mustLogIn')}
      </BuyButton>
    </ActionBarItemWrapper>
  );
};
LoginToDownloadButton.displayName = 'LoginToDownloadButton';

export default LoginToDownloadButton;
